import { logError } from "@entrilia/shared/logging";
import type { EntityFieldComponentPropsBase } from "../entityFieldTypes";
import { getInvalidFieldValueError } from "../helpers";
import EntityNumberComponent from "./EntityNumberComponent";

const EntityMoneyField = ({
  value,
  fieldId,
  fieldConfiguration,
  fieldAttributes,
  onChange,
  fieldInputId,
}: EntityFieldComponentPropsBase) => {
  if (typeof value !== "number" && value !== undefined && value !== null) {
    logError(getInvalidFieldValueError(fieldId, fieldConfiguration?.$type, value), "[EntityMoneyField]");
    return null;
  }

  return (
    <EntityNumberComponent
      fieldId={fieldId}
      fieldConfiguration={fieldConfiguration}
      fieldAttributes={fieldAttributes}
      fieldInputId={fieldInputId}
      value={value}
      onChange={onChange}
    />
  );
};

export default EntityMoneyField;
